/**
 * Lengtegrenzen van de dagboekvelden, gelijk aan de backendvalidatie
 * (`ModelConstraints.IChingQuestionMaxLength` en `IChingNotesMaxLength`): vraag max 2000 tekens, notities max 20000.
 */
export const ICHING_LIMITS = {
  question: 2000,
  notes: 20000,
} as const;
